import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const FIELD_LABEL_CLASS = "text-xs font-semibold uppercase tracking-wide text-muted-foreground";

interface TagsInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export function TagsInput({ value, onChange, placeholder }: TagsInputProps) {
  return (
    <div>
      <Label className={FIELD_LABEL_CLASS}>Tags</Label>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1.5"
      />
      <p className="text-xs text-muted-foreground mt-1">Comma-separated.</p>
    </div>
  );
}
